// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { _DYN_BASE_DATA } from "../../../__DynamicConstants";
/**
 * @deprecated - will be removed in future releases as this was only used by the applicationinsights-channel-js package.
 * And it no longer uses this class.
 */
var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* FieldType.Required */,
            baseData: 1 /* FieldType.Required */
        };
        this.baseType = baseType;
        this[_DYN_BASE_DATA /* @min:%2ebaseData */] = data;
    }
    return Data;
}());
export { Data };
//# sourceMappingURL=Data.js.map